module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter3"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block8"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TOC"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps-rw"
  }, [_vm._v("HAPTER")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps-rw"
  }, [_vm._v("HREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p281"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/leftswoosh_rev1_svg_online.png"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "Images/rightswoosh_rev1_svg_online.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p282"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("R")]), _vm._v("obert gazed at Mariah Winslow over the rim of his glass as he took another swallow of bourbon. He certainly needed a drink after witnessing that familial battle of wills.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p283"
    }
  }, [_vm._v("He’d anticipated that the Hellion wouldn’t be happy to be harnessed by society’s rules, but he certainly hadn’t expected "), _c('i', [_vm._v("this")]), _vm._v(". Or that she actually thought Winslow would consider her for the partnership. It might have been a family business, but family usually meant sons and sons-in-law. There were few examples of daughters being allowed into businesses as anything more than figureheads, and even then only with small companies. And none that brought them into contact with sailors and longshoremen.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p284"
    }
  }, [_vm._v("In Winslow’s boots, he most likely would have done the same. Yet he understood her frustration.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p285"
    }
  }, [_vm._v("He slowly lowered the glass. “So you want to be a partner in your father’s company.” There was no point in dancing around the subject, not when it hung in the air as palpable as the snow falling beyond the bay windows.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p286"
    }
  }, [_vm._v("“I do.” She folded her hands behind her back, although less likely from demureness and more to keep herself from scratching his eyes out. “And you think you’re going to be able to marry me off?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p287"
    }
  }, [_vm._v("“I do.” With the help of his mother, his sister, fate, a prevailing trade wind, and nonstop prayers to God. “I’ll certainly give it my best shot.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p288"
    }
  }, [_vm._v("Her lips curled in amusement, and a low warning prickled at the backs of his knees. “And I as well.” Her green eyes gazed at him innocently enough, but something told him that they’d just agreed to two completely different outcomes. She tilted her head thoughtfully. “Lord Robert Carlisle…how do I know that name?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p289"
    }
  }, [_vm._v("“My father was the late Duke of Trent.” He fought back a grimace. He disliked acknowledging his connection to the title, preferring to be known for his own accomplishments.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p290"
    }
  }, [_vm._v("“That’s not it.” Her catlike eyes swept over him, blatantly sizing him up. Like an opponent before a fight.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p291"
    }
  }, [_vm._v("“My mother is active in society events. Perhaps you two met at a soiree.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p292"
    }
  }, [_vm._v("“Oh, I’m quite certain "), _c('i', [_vm._v("that’s")]), _vm._v(" not it. You see, I don’t have time for frivolities.” Her smile never moved, yet it seemed to harden. Which was a damnable shame, because she had a very sensuous mouth. The kind a man could enjoy kissing for hours. “I’m too busy following the trade business to bother waltzing at balls.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p293"
    }
  }, [_vm._v("“Of course,” he murmured, certain she didn’t spend much time at society events. He’d have remembered meeting her…a dark rose among the pastel daisies of the unmarried ladies. And she certainly had thorns. “My brothers, then.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p294"
    }
  }, [_vm._v("“Pardon?” She blinked, surprised by that sudden turn of conversation.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p295"
    }
  }, [_vm._v("“The Carlisle brothers,” he explained, a touch ruefully. “We made quite a reputation for ourselves in our younger days. That must be where you’ve heard of me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p296"
    }
  }, [_vm._v("“Perhaps.” She gave a dismissive sniff. “But I definitely know it wasn’t in praise for being a good businessman.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p297"
    }
  }, [_c('i', [_vm._v("Thorns")]), _vm._v(", indeed. But she’d have to try a lot harder than that tiny prick to wound him. “Your father thinks my business acumen enough to benefit the company.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p298"
    }
  }, [_vm._v("“Papa thinks he can use you to gain influence in Parliament,” she corrected quietly but bluntly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p299"
    }
  }, [_vm._v("He finished off the rest of his bourbon, hiding the sting to his pride. “I know.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p300"
    }
  }, [_vm._v("Surprise flickered in her eyes. Clearly, she’d thought him either too naïve or too daft to have figured out the real reason why he, of all men, was important to Winslow. But he’d known from the beginning.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p301"
    }
  }, [_vm._v("He crossed the room to the tantalus and refilled his glass. “My brother Sebastian, the current Duke of Trent, sits on several important committees in Parliament, including the committee which governs trade and tariffs. So does the Duke of Chatham, the father of my brother-in-law, the Marquess of Chesney, who will someday take over for him in Parliament.” He reached for a second crystal tumbler and splashed in two fingers’ worth of bourbon. “And my family maintains a strong friendship with the Duke of Strathmore, although the duke’s interests lean more toward the military than commerce, but one never knows when privately held ships might be called into commission or when merchants might need to supply army provisions.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p302"
    }
  }, [_vm._v("Even though he’d never deign to exploit the connections he’d so glibly listed, he took pleasure in inverting her opinion of him as someone who didn’t realize his own worth. He’d certainly considered the power of all his connections many times while he’d been researching Winslow Shipping.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p303"
    }
  }, [_vm._v("He continued, “My cousin, Ross Carlisle, Earl of Spalding, is currently a high-level diplomat within the Court of St James’s, and my brother Quinton is well on his way to someday being elected an MP from Cumbria, if the villagers don’t decide to tar and feather him first.” He carried both drinks back to her. “All in all, I’d say those connections are worth a twenty percent stake.” He held out the second glass toward her, his eyes not leaving hers. “Don’t you agree?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p304"
    }
  }, [_vm._v("A burst of satisfaction spun through him at the flash of annoyance in her eyes. If the minx wanted a bare-knuckle fight, he’d give her one that would make Gentleman Jackson take note. This partnership was his best hope to put his father’s ghost to rest and repent for his sins, and no one would stand in his way. "), _c('i', [_vm._v("No one.")]), _vm._v(" Certainly not some green-eyed harridan, no matter how curvaceous her lithe body or how tempting those berry-red lips, which on any other woman would have appeared too full but on her were succulently ripe.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p305"
    }
  }, [_vm._v("Her gaze darted suspiciously to the bourbon. “Did you poison it?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p306"
    }
  }, [_vm._v("“And ruin fine Kentucky bourbon?” He quirked a brow as if offended. “Do you take me for a heathen?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p307"
    }
  }, [_vm._v("A faint smile tugged at her lips, the first genuinely amused expression he’d seen from her since she walked into the room. And it was surprisingly nice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p308"
    }
  }, [_vm._v("But it faded quickly, and she coolly accepted the glass. “At least you appreciate good liquor,” she grudgingly muttered, then took a sip. “Most Englishmen consider bourbon beneath them, preferring to spend twice as much for cognac that’s half as good.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p309"
    }
  }, [_vm._v("He raised his glass toward her in a casual toast. “I am not one of those men.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p310"
    }
  }, [_vm._v("Her eyes gleamed at that, as if she might find respect for him after all. “My father deals in the finest bourbons. It’s one of the perks of trading with the Americans. That, and we also get the best coffees and cocoas.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p311"
    }
  }, [_vm._v("“And cigars,” he added knowingly. “Winslow Shipping traded more than six thousand pounds in American cigars last year.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p312"
    }
  }, [_vm._v("“Impressive.” The tip of her tongue darted out to innocently lick away a drop of bourbon still clinging to her upper lip, but he felt that small lick burn through him like liquid fire. "), _c('i', [_vm._v("Sweet Lucifer.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p313"
    }
  }, [_vm._v("If he couldn’t find her a husband by August, it would only be because the devil himself wanted to keep her for his own wanton pleasures.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p314"
    }
  }, [_vm._v("“I’ve studied your father’s company, Miss Winslow, and I know what goods he specializes in, which countries his ships sail to, which merchants he buys from at all ports of call, just as I know the best buyers in England where he can sell those goods for the most profit and how to leverage that profit once we have it. I assure you, he’s found a good partner in me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p315"
    }
  }, [_vm._v("“But you’re not a Winslow.” She eyed him over the rim of her glass as she held it thoughtfully to her lips. “Tell me, Lord Robert—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p316"
    }
  }, [_vm._v("“Just Robert,” he corrected. He hated that appellation, preferring to make his own mark away from the shadow of the title. “Or Carlisle, if you prefer. There’s no room for courtesies in business.” "), _c('i', [_vm._v("Or in war.")]), _vm._v(" And he had the sinking feeling he’d just stumbled unwittingly into the fray.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p317"
    }
  }, [_vm._v("“Carlisle,” she repeated distastefully, nearly making him laugh with how evident her dislike of him was. Not that it mattered what she thought of him. Certainly, an amiable relationship would make the season easier for both of them, but he’d walk through the flames of hell to prove himself if he had to. “Do you take the same position as my father? That business is the realm of men and that ladies should do nothing more taxing than watercolors?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p318"
    }
  }, [_vm._v("“I don’t believe that’s what your father thinks,” he murmured, remembering Winslow’s words about fulfilling his late wife’s wishes to turn their daughters into ladies. And sympathizing immensely with the man’s frustrations, now that he’d met his daughter.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p319"
    }
  }, [_vm._v("“Do you?” she pressed.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p320"
    }
  }, [_vm._v("He couldn’t help a twitch of his lips at her doggedness. “One doesn’t hold that view among the Carlisle women and live a long life.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p321"
    }
  }, [_vm._v("The quick narrowing of her eyes told him she wasn’t satisfied with his answer. “Do "), _c('i', [_vm._v("you")]), _vm._v(" believe that?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p322"
    }
  }, [_vm._v("He took a slow step toward her, inexplicably drawn to the fight in her. Like a moth to a flame, he was unable to stop himself, even though he knew the fire would most likely burn. “I believe, Miss Winslow,” he clarified quietly but firmly, wanting no mistake between them on this point, “that ladies are capable of holding their own against gentlemen in nearly every endeavor—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p323"
    }
  }, [_vm._v("“"), _c('i', [_vm._v("Nearly")]), _vm._v(" every?” she echoed.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p324"
    }
  }, [_vm._v("Good Lord. Was the Hellion a reformer, too? The more he learned about her, the more he realized exactly how monumental the task was that Winslow had given him to find her a husband.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p325"
    }
  }, [_vm._v("“Nearly every,” he repeated, thinking of all the antics he and his brothers had committed during their reign of terror. Some of those were certainly not fit for ladies. Or most men. “Including business. I’ve no doubt that you would make a fine partner.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p326"
    }
  }, [_vm._v("That surprised her, based on the flicker in her green eyes. “Well, then you concede—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p327"
    }
  }, [_vm._v("“But I would be a better one.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p328"
    }
  }, [_vm._v("With that, he stunned her, and long enough that he was able to take another step to close the distance between them, remove the glass from her hand, and set it aside before she decided to fling its contents at him. Which would be a true waste of fine bourbon.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p329"
    }
  }, [_vm._v("“I have no intention of surrendering this opportunity,” he told her frankly. Directness seemed to garner more of her respect than subtlety, so he’d gladly oblige. And found it surprisingly refreshing to be able to be so blunt with a woman. “Not even to you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p330"
    }
  }, [_vm._v("Neither of them moved in the silence that followed that declaration, both unwilling to back down.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p331"
    }
  }, [_vm._v("As they faced each other, he noted that they were almost evenly matched for height. She barely had to tilt her head back to look up at him, her lips very nearly level with his…those same lips that even now twisted tightly together in an aggravated grimace. What would it taste like, that sensuous mouth of hers that reminded him of a ripe cherry, all dark red and juicy? Inexplicably tart and sweet at the same time? Or would it have the bite of a poison apple?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p332"
    }
  }, [_vm._v("“Then you’re going to have a difficult task ahead of you, I’m afraid,” she whispered, and God help him, he leaned in to catch each word.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p333"
    }
  }, [_vm._v("“Not so difficult,” he countered, his deep voice far huskier than he’d intended. But the hellcat had him saying all kinds of things he didn’t intend, including, “You’re beautiful.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p334"
    }
  }, [_vm._v("Her lips parted in surprise. He nearly chuckled as he stared at her. For once, he’d left her speechless.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p335"
    }
  }, [_vm._v("Risking a slap, yet unable to stop himself, he reached to touch one of the ebony tendrils framing the side of her face and rubbed the lock between his thumb and forefinger. His gut tightened at the smooth feel of it. Like black silk. Which immediately made him wonder if her bare skin would feel just as silky beneath his hands.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p336"
    }
  }, [_vm._v("Her breath hitched, and her wide eyes dropped to his mouth, lingering there on his lips.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p337"
    }
  }, [_vm._v("Did the minx want him to kiss her? Those lips, that hair…How many men had succumbed to her spell and done just that? And how many hadn’t survived?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p338"
    }
  }, [_vm._v("“Intelligent and sharp,” he murmured.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p339"
    }
  }, [_vm._v("She stood perfectly still beneath his touch, except for a nervous swallow that undulated softly in her throat and had him wanting to place his lips right there against her neck to feel it. And against the pulse he could see racing in the hollow at her collarbone even now. Was it arousal that had her senses alert, her pulse racing? Or fury?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p340"
    }
  }, [_vm._v("Shamelessly, he didn’t care which. Even now she had him longing to take far more intimate touches than the mere stroking of her hair that he was so brazenly stealing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p341"
    }
  }, [_vm._v("“And an heiress,” he murmured. “What man could resist?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p342"
    }
  }, [_vm._v("She blinked, breaking the spell. “An heiress?” she repeated, her breathless voice evidence that she’d been affected by his caress. “Is that what you think?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p343"
    }
  }, [_vm._v("“Of course.” What would she do if he dared to trace his thumb over her bottom lip? Would this hellcat sigh with pleasure or sink her teeth into his flesh in attack?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p344"
    }
  }, [_vm._v("“But didn’t Papa tell you?” A throaty laugh of surprise fell from her. “I have no dowry.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p345"
    }
  }, [_vm._v("Clenching his jaw as the lilting sound of her laugh twisted into his gut like a knife, he dropped his hand away. No dowry, with "), _c('i', [_vm._v("her")]), _vm._v(" reputation—"), _c('i', [_vm._v("Christ")]), _vm._v(". He’d been bitten, all right.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p346"
    }
  }, [_vm._v("She clucked her tongue disapprovingly. “First rule of business: never commit to an agreement until you know all the terms.” A victorious gleam lit her eyes. “"), _c('i', [_vm._v("All")]), _vm._v(" the terms.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p347"
    }
  }, [_vm._v("Ignoring her baiting, he fought to keep the incredulity from his face. “You don’t have a dowry?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p348"
    }
  }, [_vm._v("“Not one ha’penny.” With the smile of the cat that ate the canary, she turned away from him, snatching up her glass of bourbon as she went. “Neither of us Winslow daughters do. Oh, Papa is wealthy enough to negotiate a fine marriage settlement, but he doesn’t believe in them.” She paused in front of the fireplace. “Marital bribery, in his opinion.” Bracing her arm against the mantel, she gestured with the glass and puffed out her chest in an impression of Henry Winslow. “‘If a man wants my money, let him come to work for me to get it!’”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p349"
    }
  }, [_vm._v("A rather good impression, he admitted grudgingly, as the harsh realization of what he was truly up against spiraled through him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p350"
    }
  }, [_vm._v("“‘If he wants my daughter, then money shouldn’t matter.’” She raised the glass in a toast as she belted out in a deep voice that sounded eerily like her father’s, “‘And if he wants both my money "), _c('i', [_vm._v("and")]), _vm._v(" my daughter, then he is a greedy bastard who deserves neither!’”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p351"
    }
  }, [_vm._v("With a flourish of the glass in the air, she finished the impression by tossing back the remaining bourbon in a single swallow. And "), _c('i', [_vm._v("that")]), _vm._v(" was as equally impressive as the impersonation.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p352"
    }
  }, [_vm._v("Applauding her performance with a slow clapping of his hands, he walked toward her. “Very nicely played.” He bit back his opinion that she had better odds of becoming a successful actress than she did of gaining the partnership, wanting to escape the afternoon unslapped. “But the man you marry will still become part of Winslow Shipping. His share of the company serves as your dowry.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p353"
    }
  }, [_vm._v("“No.” Her eyes grew serious, all traces of her previous teasing vanishing. “My father will never bring a son-in-law into the business. You see, my grandfather did with the man my aunt married, giving him both her dowry and a large part of the company, only to watch him change into a drunkard and a gambler. He turned my aunt against her family, then ruined the marriage and nearly destroyed the company before they were able to force him out. Until the day she died, my aunt never again spoke to my father.” She shook her head sadly, as if grieving for all that her family had lost. “Papa might eventually relent and bestow a dowry, but believe me when I tell you that he will "), _c('i', [_vm._v("never")]), _vm._v(" relent on that.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p354"
    }
  }, [_vm._v("The hole around him grew deeper, and the sensation gripped him that the partnership was once more slipping through his fingers. “Then your husband will wait until your father dies to get his due.” He was grasping at straws now. "), _c('i', [_vm._v("Anything")]), _vm._v(" to keep hold of this opportunity. “You’ll still be an heiress, dowry or not.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p355"
    }
  }, [_vm._v("“Unlikely. Knowing Papa, he’s probably left the company to some distant relative none of us knows just to keep Winslow Shipping out of the hands of fortune hunters.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p356"
    }
  }, [_vm._v("Which was exactly something Henry Winslow would do. The same things that drew Robert’s interest in partnering with him—his success, his shrewdness, his belief that a man needed to prove his worth—now cut like a double-edged sword.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p357"
    }
  }, [_vm._v("“Doesn’t it bother you that he’s made it so difficult for you to secure a husband?” he bit out, wanting commiseration in his mounting frustration.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p358"
    }
  }, [_vm._v("“Actually, in that,” she replied with full sincerity, “I agree with him. It would be terrible to wonder which my husband wanted more, my money or me. This way, I’ll know he wants me.” She gave a soft sigh, as if she’d often pondered exactly that. “So you see, it isn’t going to be as easy to marry me off as you think. You’ll have to find suitors who want to court me because they actually "), _c('i', [_vm._v("like")]), _vm._v(" me, and, well…” She shrugged as if it were the most obvious thing in the world. “I’ll make it difficult for anyone to like me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p359"
    }
  }, [_vm._v("“Oh, I’m certain of that,” he muttered.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p360"
    }
  }, [_vm._v("She laughed with a genuine amusement that fell through him like a warm summer breeze.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p361"
    }
  }, [_vm._v("Frustration blistered inside him. If the damned woman wanted to, she could easily find a man willing to take her for her beauty and mind. Dowry be damned. Her wit alone could keep a man happily challenged for years.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p362"
    }
  }, [_vm._v("Yet he also knew the slim odds of finding a love match for a woman hanging on to the fringe of society by her fingertips.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p363"
    }
  }, [_vm._v("“Don’t you want a husband?” he pressed. “A family and home of your own?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p364"
    }
  }, [_vm._v("“I’d rather have Winslow Shipping.” Her voice emerged so intensely that it quavered. “The company "), _c('i', [_vm._v("is")]), _vm._v(" my family, as much a part of me as any child could ever be.” She took a deep breath, and he knew she was genuinely trying to make him understand. “I have wanted to help my father run the business since I was a little girl, since the first time I visited the wharves. I was mesmerized by all those ships, by the sailors and porters as they worked. Papa showed me everything, pointing out all the small details and explaining how trade worked. It was magical, and I have never forgotten it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p365"
    }
  }, [_vm._v("Coming from anyone else, he would have called her speech poetic and naïve. But from her, the words landed with quiet authority and heartfelt dedication. She was no simpering debutante bedazzled by the sights of the season; she was a woman in full, one who knew exactly what she wanted. He should have felt the cut of that hard edge to her, yet she fascinated him even more because of it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p366"
    }
  }, [_vm._v("“I won’t let you take my place at my father’s side,” she said, as calmly as if stating a fact about the weather. "), _c('i', [_vm._v("Rain falls down, winters are cold…I won’t let you win.")]), _vm._v(" “The best partner for Winslow Shipping is a Winslow. Always has been, always will be.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p367"
    }
  }, [_vm._v("At that declaration, he reached past her shoulder to set his glass on the mantel and leaned in close, bringing his face level with hers. Close enough that he could see flecks of gold in her emerald eyes and smell the exotic scent of orange and cinnamon lingering on her skin. He touched her hair again, and this time as he pulled away he let his knuckles caress across her cheek, even as he carefully kept his fingers out of biting range.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p368"
    }
  }, [_vm._v("“You don’t have a choice,” he reminded her. A faint blush pinked her cheeks, and he couldn’t help but faintly smile at her reaction. That she should react so strongly to such a little touch…"), _c('i', [_vm._v("Remarkable.")]), _vm._v(" “Unless you want to be cut off, you have to do as required of you this season.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p369"
    }
  }, [_vm._v("Her bottom lip jutted up defiantly. “Papa will see sense and relent. He always does.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p370"
    }
  }, [_vm._v("His gaze fixed on her mouth. If she wasn’t careful, a man might just feel compelled to wipe that disobedient smirk off her lips with his. And enjoy it immensely. “Not this time. He’s expecting you to fully participate in the season and make a valiant attempt at finding a husband. If you refuse to cooperate, you’ll lose.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p371"
    }
  }, [_vm._v("“Then so will you,” she countered, her soft breath spicy-sweet as it fanned his lips and vibrated an electric tingle through him. “Because you won’t succeed at your test, and you won’t get the partnership.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p372"
    }
  }, [_vm._v("Unable to resist any longer, and thoroughly willing to risk a bite, he brushed his thumb over her bottom lip.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p373"
    }
  }, [_vm._v("She gasped, her lips parting in surprise. Yet she didn’t step away.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p374"
    }
  }, [_vm._v("Emboldened by her defiance, and enchanted by the fire inside her, he slowly traced his fingertip around her mouth, drawing the outline of her full lips. When she trembled, the electric tingle inside him turned into a yearning ache. "), _c('i', [_vm._v("Never")]), _vm._v(" had he wanted to kiss a woman more than he did at that moment.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p375"
    }
  }, [_vm._v("“I’m willing to take that chance,” he drawled in a low voice, then quirked a brow in challenge. “Are you?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p376"
    }
  }, [_vm._v("As if considering her options and finding no escape from her father’s plans for her, she stared at him silently, her eyes shining with unshed tears of frustration. She whispered, each word a warm breath against his fingers, “I will "), _c('i', [_vm._v("never")]), _vm._v(" surrender.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p377"
    }
  }, [_vm._v("Admiration for her perseverance flared inside him, and he murmured, “I would be disappointed if you did.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p378"
    }
  }, [_vm._v("He dropped his hand to his side and stepped back. Oh, certainly to keep from touching her again, although this time more than likely to throttle her. Then he turned on his heel and walked away.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p379"
    }
  }, [_vm._v("“I might have to participate in this fiasco of a season,” she called after him as he headed toward the door, “but I certainly don’t have to make it easy on you.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p380"
    }
  }, [_vm._v("“From you, Miss Winslow,” he replied with a heavy sigh, acknowledging her tenacity if not the aggravation she sparked inside him, “I would expect nothing less.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p381"
    }
  }, [_vm._v("With that declaration of war, he politely inclined his head and stepped from the room.")]), _vm._v(" "), _c('div', {
    staticClass: "decoration-rw",
    attrs: {
      "id": "decoration1"
    }
  }, [_c('p', {
    staticClass: "center-rw",
    attrs: {
      "id": "p382"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p383"
    }
  }, [_vm._v("Still muttering to herself as she’d done during the entire hour-long carriage ride from Mayfair to St Katharine’s, Mariah hurried up the front steps of the massive stone house that served as the Gatewell School for Orphans of the Sea, cursing Robert Carlisle, his connections in Parliament, and every one of his ancestors whose procreation culminated in "), _c('i', [_vm._v("him")]), _vm._v(". A man so infuriating that she could barely see straight by the time he’d so arrogantly sauntered from the drawing room.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p384"
    }
  }, [_vm._v("The audacity of that man! To come sweeping into her life to take the company away from her. To turn her father against her. To force a season upon her, with the end goal of marrying her off…oh, the mortification of it! And to dare to touch her the way he did—")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p385"
    }
  }, [_vm._v("Well, perhaps "), _c('i', [_vm._v("that")]), _vm._v(" wasn’t so awful. Except that behind the caresses stood the devil himself, gleefully ready to take her soul.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p386"
    }
  }, [_vm._v("She swiped at her eyes as she hurried through the maze of rooms that comprised both school and safe haven to children whose fathers had died at sea or working on the wharves. The solidity of this old house with its sagging roof and cracked walls had always brought her comfort. So had the knowledge that she was helping children just like her mother, who had lost her own father to the sea. Every time Mariah entered this building, she felt Mama smile, as if she were watching over her from heaven.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p387"
    }
  }, [_vm._v("But today, even the school couldn’t bring her peace.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p388"
    }
  }, [_vm._v("Doing her best to force from her mind the image of Carlisle’s infuriating grin, she ran down the back stairs and into the kitchen in search of Mrs. Smith, the woman who served as both housekeeper and cook for the school. On the tip of her tongue she held an angry rant about Carlisle so venomous that she was certain it would peel the whitewash from the walls once she unleashed it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p389"
    }
  }, [_vm._v("But she halted in the middle of the doorway. Inside the kitchen, Mrs. Smith pulled a fresh sheet of biscuits from the oven, and Hugh Whitby sat perched on a stool at the table, relating some juicy bit of gossip while rolling out little balls of dough.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p390"
    }
  }, [_vm._v("At the sight of her two dearest friends, an anguished sob tore from her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p391"
    }
  }, [_vm._v("Mrs. Smith looked up and dropped the sheet onto the table with a clatter. “Mariah!” Concern instantly gripped her. “My dear, whatever is the—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p392"
    }
  }, [_vm._v("But Whitby had already sprung to his feet and hurried to her, to slip an arm around her shoulders and gently help her sit on one of the chairs. By then, she was sobbing uncontrollably. All the anger and betrayal from that morning’s introduction to that horrible man came surging out of her in an unbridled wave of wretchedness.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p393"
    }
  }, [_vm._v("“Mariah?” Whitby’s face paled at her tears, making his sky-blue eyes and shock of ginger hair stand out even more than usual as he knelt in front of her and fished a handkerchief from his waistcoat pocket. “What’s happened?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p394"
    }
  }, [_vm._v("Blowing her nose on the handkerchief, she poured out a description of that morning’s events, carefully leaving out the part when that rake had touched her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p395"
    }
  }, [_vm._v("When she finished her story, her shoulders were straighter, and her chest was lighter. She felt better, as she always did after unburdening herself to her friends. Yet she wasn’t naïve enough to dismiss so easily the oncoming storm set to rush over her during the months to come.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p396"
    }
  }, [_vm._v("“"), _c('i', [_vm._v("Robert")]), _vm._v(" Carlisle?” Whitby repeated incredulously, moving back to his stool as Mrs. Smith set a cup of tea on the table in front of her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p397"
    }
  }, [_vm._v("She sniffed. “You know him?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p398"
    }
  }, [_vm._v("“My brothers knew him at Eton. They told all kinds of stories about the Carlisles and how they were always being reprimanded by the prefect.” He grinned, a goofy smile that was all big teeth and dimples and somehow just as gangly as the rest of him. “Don’t know how they never got expelled.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p399"
    }
  }, [_vm._v("Her fingers tightened around the handkerchief. "), _c('i', [_vm._v("This")]), _vm._v(" was the man her father wanted to run Winslow Shipping?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p400"
    }
  }, [_vm._v("“Of course, I don’t believe all those stories.” Whitby shook his head as he logically deduced, “I mean, how could a cow fit inside a carriage?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p401"
    }
  }, [_vm._v("Her tear-blurred eyes widened.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p402"
    }
  }, [_vm._v("“And as for those Chinese acrobats, why, I don’t think there are that many in all of England. Certainly not enough to fill an entire vicarage!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p403"
    }
  }, [_vm._v("Mariah’s heart lurched.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p404"
    }
  }, [_vm._v("“Now, Mr. Whitby,” Mrs. Smith scolded lightly, setting a plate of warm biscuits on the table, “Mariah doesn’t want to hear stories like that.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p405"
    }
  }, [_vm._v("Certainly not!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p406"
    }
  }, [_vm._v("“She wants to hear about the man’s character,” the housekeeper explained, “and be assured of his good intentions.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p407"
    }
  }, [_vm._v("“"), _c('i', [_vm._v("Robert Carlisle?")]), _vm._v("” Whitby blurted out. “I’m not certain he has any—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p408"
    }
  }, [_vm._v("“Whitby!” Mariah pleaded. He was a dear friend, but if he didn’t stop talking, she might very well have to shove a biscuit into his mouth to silence him. She groaned and hung her head in her hands. “What am I going to do?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p409"
    }
  }, [_vm._v("“There, there now.” Mrs. Smith put her arm around her shoulders and gave her a squeeze. “’Twill work out all right in the end. You’ll see.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p410"
    }
  }, [_vm._v("Mariah shook her head and reached for the cup of tea, to hold it between her trembling hands and take comfort in its warmth. “How can it? I’m being compelled into a season against my will at the hands of a horrible man.” One who apparently forced innocent cows into carriages and hordes of acrobats onto parish vicars. God only knew what that portended for "), _c('i', [_vm._v("her")]), _vm._v(". “I’m caught. Either way I lose the partnership.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p411"
    }
  }, [_vm._v("Whitby’s face softened sympathetically. He knew how much that dream meant to her of being the next generation of Winslows to guide the business into the future, to have once more that feeling of closeness with her father that she’d experienced so long ago. But she also suspected, despite Whitby’s ever-present optimism, that he’d never truly expected it to come true.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p412"
    }
  }, [_vm._v("“You don’t have to go through with this, Mariah,” he told her.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p413"
    }
  }, [_vm._v("“If I don’t, I lose my allowance,” she reminded him quietly. “And if I lose my allowance…” She waved her hand at the old house around them. “Then Gatewell loses, too. And we cannot afford to lose a single farthing.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p414"
    }
  }, [_vm._v("“I’ll ask my father to—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p415"
    }
  }, [_vm._v("“No.” She affectionately squeezed his hand. “Your father has already been extremely generous.” The baron owned the building and let the school use it for free as long as they kept up the property. Without Whitby’s father, the school would have to relocate. But without her allowance, it would have to close completely. “This is my problem, and I’ll find a solution.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p416"
    }
  }, [_vm._v("Whitby’s boyish face turned uncharacteristically solemn as he popped one of the biscuits into his mouth and chewed thoughtfully, his mind racing to solve her problem. That was what she loved most about Whitby. He was loyal beyond measure.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p417"
    }
  }, [_vm._v("Mrs. Smith sat in the chair across the table from Whitby and reached for the bowl of dough, keeping her flour-whitened hands busy rolling out balls. And "), _c('i', [_vm._v("that")]), _vm._v(" was what Mariah loved most about Mrs. Smith—her unfailing belief that tea and biscuits could solve any dilemma. “You know, it might not be as bad as you think.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p418"
    }
  }, [_vm._v("“Because it might be even worse?” she sighed out miserably.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p419"
    }
  }, [_vm._v("Mrs. Smith’s lips twisted into an expression of motherly disapproval. “You’ve never had a real season.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p420"
    }
  }, [_vm._v("“I’ve had six,” Mariah reminded her with chagrin.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p421"
    }
  }, [_vm._v("“No, my dear.” She placed a ball on the sheet and pushed the bowl toward Whitby to once more get his help, although Mariah suspected it was done more to keep him from eating up all the biscuits that were already cooling. “You’ve never had a proper season. Not the kind you deserve.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p422"
    }
  }, [_vm._v("She countered defensively, “My seasons were just fine.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p423"
    }
  }, [_vm._v("“You had no invitations, no gowns, absolutely no suitors—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p424"
    }
  }, [_vm._v("“Thank you,” Mariah grumbled sardonically.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p425"
    }
  }, [_vm._v("“And you deserve to have it all. To be Cinderella in the fairy tale.” Mrs. Smith gave a dreamy sigh. “Now you have the opportunity for a proper introduction, and under the guidance of a duchess, no less! A chance to meet all the most eligible gentlemen, attend all the best events, perhaps waltz with a duke—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p426"
    }
  }, [_vm._v("Mariah laughed at that.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p427"
    }
  }, [_vm._v("“And what’s so amusing? A duke should consider himself lucky to dance with a beautiful lady like you.” When Mariah rolled her eyes, Mrs. Smith gently kicked Whitby under the table. “Tell her, Mr. Whitby, how beautiful she is.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p428"
    }
  }, [_vm._v("“What?” Whitby glanced up and blinked, startled from his own thoughts.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p429"
    }
  }, [_vm._v("“Don’t you think that Mariah’s beautiful?” Mrs. Smith prompted.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p430"
    }
  }, [_vm._v("He glanced at Mariah and blinked again. “Oh yeah, sure.” Then he reached for another biscuit.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p431"
    }
  }, [_vm._v("Mariah smiled. Whitby, always true to form.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p432"
    }
  }, [_vm._v("She took the biscuit from his fingers just as he was about to pop it into his mouth and broke it in two, then handed him half. He grinned at her and gobbled it down, while she nibbled slowly at her own half.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p433"
    }
  }, [_vm._v("“And what’s the worst that can happen, truly?” Mrs. Smith placed the last ball on the sheet, then pressed a spoon gently down on each to flatten them. “At the very worst, you have a boring time. And at best…” She shrugged and pushed herself away from the table to carry the baking sheet to the oven. “You might find a husband.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p434"
    }
  }, [_vm._v("Mariah choked.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p435"
    }
  }, [_vm._v("“Not if you don’t want to, of course, but one whom you love,” Mrs. Smith corrected quickly as Whitby slapped Mariah on the back as she coughed. “No one can force you into marriage against your will, not even your father.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p436"
    }
  }, [_vm._v("True. Although it certainly felt like it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p437"
    }
  }, [_vm._v("“But to meet a man whom you might actually "), _c('i', [_vm._v("want")]), _vm._v(" to marry…,” Mrs. Smith pondered gently, refilling her teacup. “Wouldn’t that be wonderful?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p438"
    }
  }, [_vm._v("Whitby grinned. “Mariah get married? Now "), _c('i', [_vm._v("that’s")]), _vm._v(" a society event I’d pay to attend!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p439"
    }
  }, [_vm._v("Scowling, Mariah threw her biscuit at him. He caught it and popped it into his mouth.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p440"
    }
  }, [_vm._v("Mrs. Smith sighed heavily. “Stranger things have been known to happen.” She fetched a baked sheet of biscuits from the oven and spooned each one carefully onto the rack, smacking Whitby’s fingers when he reached for one. “Besides, this might work to your advantage.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p441"
    }
  }, [_vm._v("“How so?” She couldn’t imagine any scenario in which being paraded about for men to gawk at, like some creature from the Tower Menagerie, could possibly be an advantage.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p442"
    }
  }, [_vm._v("“It might prove to your father that you’re willing to do as he asks instead of rebelling, which might be exactly what he wants in a business partner.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p443"
    }
  }, [_vm._v("“I wasn’t "), _c('i', [_vm._v("rebelling")]), _vm._v(",” she muttered and risked a smack of the spoon by reaching for a warm biscuit herself. “But even Cinderella rebelled, first against her wicked stepmother and then by pretending to be something she wasn’t.” She shook the biscuit at Mrs. Smith to make her point. “Do you really think the prince would have danced with her if he’d known she was only a scullery maid? Then, afterward, when she pretended to be a dutiful stepdaughter again only to hide—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p444"
    }
  }, [_vm._v("She stopped suddenly, her eyes darting between her two friends as a wonderful idea popped into her head. A wonderfully, deliciously "), _c('i', [_vm._v("devilish")]), _vm._v(" idea!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p445"
    }
  }, [_vm._v("“Oh, that’s it,” she practically purred, resting the biscuit thoughtfully against her lips. “That’s what I’ll do…”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p446"
    }
  }, [_vm._v("“Pardon?” Mrs. Smith’s mouth drew down warily.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p447"
    }
  }, [_vm._v("Mariah sent her a sly smile. “I’m going to do "), _c('i', [_vm._v("exactly")]), _vm._v(" as you suggested.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p448"
    }
  }, [_vm._v("Her frown deepened with suspicion. “How so?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p449"
    }
  }, [_c('i', [_vm._v("Pretending to be a dutiful daughter.")]), _vm._v(" Of course, she’d have to walk a very fine line. On the surface, she’d make it look as if she were going along with Papa’s plans, participating in the season and doing whatever Carlisle and his mother asked of her, so that Papa couldn’t find fault. But underneath, she’d do everything she could to throw enough rocks under Carlisle’s wheels to prevent him from finding any suitors for her. When August arrived without a single marriage offer, he would be denied the partnership, and she would be happily "), _c('i', [_vm._v("un")]), _vm._v("married, her allowance still firmly in place. And she’d have a brand-new opportunity to convince her father that she should be allowed to help run the company.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p450"
    }
  }, [_vm._v("Oh, it was simply perfect!")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p451"
    }
  }, [_vm._v("With a happy laugh, she announced, “I am going to be just like Cinderella!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p452"
    }
  }, [_vm._v("Except that when her fairy godmother waved her magic wand, it wouldn’t be a princess she turned into but her father’s business partner. And when the clock struck midnight, she’d make certain it was Carlisle who turned into a pumpkin.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p453"
    }
  }, [_vm._v("“Whitby,” she pleaded, excitement bubbling in her voice, “tell me everything you know about the Carlisles.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p454"
    }
  }, [_vm._v("“Everything?” He blinked, surprised that for once someone was actually asking to hear his stories.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p455"
    }
  }, [_vm._v("She smiled and handed over her last biscuit. “"), _c('i', [_vm._v("Everything.")]), _vm._v("”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a902b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s007-Chapter-003.vue
// module id = 78
// module chunks = 0